import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { Subscription } from 'rxjs/Subscription'
import { UserModel } from '../../../../models/user.model'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { FuseTranslationLoaderService } from '../../../../../core/services/translation-loader.service'
import { userDutch } from '../../../users/i18n/nl'
import { userEnglish } from '../../../users/i18n/en'
import { MatSnackBar } from '@angular/material'
import { fuseAnimations } from '../../../../../core/animations'
import { TranslateService } from '@ngx-translate/core'
import { AdminUsersService } from '../../services/admin-users.service'
import { TellowConstants } from '../../../enums/TellowConstants'

@Component({
  selector: 'app-admin-document-details',
  templateUrl: './admin-document-details.component.html',
  styleUrls: ['./admin-document-details.component.scss'],
  animations: fuseAnimations,
})
export class AdminDocumentDetailsComponent implements OnInit, OnDestroy {
  user: UserModel
  onUserChanged: Subscription
  userForm: FormGroup
  states = TellowConstants.getStatus()
  message: string

  @ViewChild('titleInput') titleInputField

  constructor(
    private adminUsersService: AdminUsersService,
    private formBuilder: FormBuilder,
    private translationLoader: FuseTranslationLoaderService,
    public snackBar: MatSnackBar,
    private translateService: TranslateService,
  ) {
    this.translationLoader.loadTranslations(userDutch, userEnglish)
  }

  ngOnInit() {
    // Subscribe to update the current administration
    this.onUserChanged = this.adminUsersService.onUserChanged.subscribe(user => {
      if (user != undefined) {
        this.user = user
        this.userForm = this.createUserForm()
        this.focusTitleField()
      }
    })
  }

  focusTitleField() {
    setTimeout(() => {
      this.titleInputField.nativeElement.focus()
    })
  }

  createUserForm() {
    return this.formBuilder.group({
      id: [this.user.id],
      first_name: [this.user.first_name, [Validators.required]],
      middle_name: [this.user.middle_name],
      last_name: [this.user.last_name, [Validators.required]],
      phone_number: [this.user.phone_number, [Validators.required]],
      email: [this.user.email, [Validators.required]],
      role: [this.user.role],
      status: [this.user.status],
    })
  }

  /**
   * Update a User
   */
  updateUser() {
    this.user.phone_number = this.userForm.get('phone_number').value
    this.user.first_name = this.userForm.get('first_name').value
    this.user.middle_name = this.userForm.get('middle_name').value
    this.user.last_name = this.userForm.get('last_name').value
    this.user.email = this.userForm.get('email').value
    this.user.status = this.userForm.get('status').value
    this.user.role = this.userForm.get('role').value

    // this.userService.update(this.user).subscribe();
  }

  /**
   *
   * @param $event
   */
  unSetCurrentUser($event) {
    event.stopPropagation()
    this.adminUsersService.unSetCurrentUser()
  }

  /**
   * Block a User
   * @param {UserModel} user
   */
  blockUser() {
    if (this.user.status == 2) {
      this.user.status = 3
      this.message = 'USER.BLOCKED'
    } else {
      this.user.status = 2
      this.message = 'USER.UNBLOCKED'
    }
    //
    // this.userService.block(this.user)
    //   .subscribe(data =>{
    //
    //     this.translateService.get(this.message, {})
    //       .subscribe((message: string) => {
    //         this.openSnackBar(message,'send');
    //       });
    //     this.openSnackBar('Gebruiker geblokkerd','test')
    //   });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    })
  }
  /**
   *
   * @param event
   */
  resendActivation(event) {
    event.stopPropagation()
    // this.userService.resendActivation(this.user).subscribe(data =>{
    //   this.translateService.get('USER.RESEND_SUCCESS', {})
    //     .subscribe((message: string) => {
    //       this.openSnackBar(message,'send');
    //     })
    // });
  }

  /**
   *
   * @param event
   */
  deleteUser(event) {
    event.stopPropagation()
  }

  /**
   *
   * @returns {boolean}
   */
  checkBlocked() {
    if (this.user.status === 2 || this.user.status === 3) {
      return true
    }
    return false
  }

  /**
   *
   */
  ngOnDestroy() {
    this.onUserChanged.unsubscribe()
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/ledger/admin-documents/admin-document-details/admin-document-details.component.ts